// extracted by mini-css-extract-plugin
module.exports = {"row":"multiselect_row__1yKJH","addRemoveWrapper":"multiselect_addRemoveWrapper__3EzT2","selectWrapper":"multiselect_selectWrapper__6Tua5"};